import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
   private BASE_URL = '/life-protect-calc/enums';
   currencyConfig$ = new BehaviorSubject<string>('');

  constructor(private httpClient: HttpClient) { }

getCurrencyConfig() {
    return this.httpClient.get(`${this.BASE_URL}/currency-config`)
  }

getMainEuro(){
  return this.currencyConfig$.getValue()=='EUR'
}
}